export default __webpack_public_path__ + "static/media/culture.2c76b3f8.svg";